<template>
  <el-dialog
    :title="modalType === 'add' ? '添加监测链接' : '编辑监测链接'"
    :visible.sync="visible"
    width="600px"
    :close-on-click-modal="false"
    @closed="clearForm"
  >
    <el-form :model="ruleForm" ref="ruleForm" label-width="140px" :rules="rules" class="name-ruleForm">
      <el-form-item prop="trackUrlGroupName">
        <span slot="label"><span style="color: red">*</span>监测链接名称：</span>
        <el-input placeholder="请输入监测链接名称" v-model.trim="ruleForm.trackUrlGroupName"> </el-input>
      </el-form-item>
      <el-form-item prop="actionTrackUrl">
        <span slot="label"><span style="color: red">*</span>有效触点：</span>
        <el-input placeholder="请输入有效触点链接，需以https://开头" v-model.trim="ruleForm.actionTrackUrl"> </el-input>
      </el-form-item>
      <el-form-item label="展示：" prop="trackUrl">
        <el-input placeholder="请输入展示检测链接，需以https://开头" v-model.trim="ruleForm.trackUrl"> </el-input>
      </el-form-item>

      <el-form-item label="视频播放：" prop="videoPlayTrackUrl">
        <el-input placeholder="请输入频播放检测链接，需以https://开头" v-model.trim="ruleForm.videoPlayTrackUrl"> </el-input>
      </el-form-item>
      <el-form-item label="视频播完：" prop="videoPlayDoneTrackUrl">
        <el-input placeholder="请输入视频播完检测链接，需以https://开头" v-model.trim="ruleForm.videoPlayDoneTrackUrl"> </el-input>
      </el-form-item>
      <el-form-item label="视频有效播放：" prop="videoPlayEffectiveTrackUrl">
        <el-input placeholder="请输入视频有效播放检测链接，需以https://开头" v-model.trim="ruleForm.videoPlayEffectiveTrackUrl"> </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancelForm('ruleForm')">取 消</el-button>
      <el-button type="primary" @click="saveForm('ruleForm')">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { createTrack_tt } from "@/api/platReport";

const validateUrl = (rule, value, callback) => {
  if (value && !/(https):\/\/([\w.]+\/?)\S*/.test(value)) {
    callback(new Error("链接需以https://开头"));
  } else {
    callback();
  }
};

export default {
  data() {
    return {
      ruleForm: {
        trackUrlGroupName: "",
        trackUrl: "",
        actionTrackUrl: "",
        videoPlayTrackUrl: "",
        videoPlayDoneTrackUrl: "",
        videoPlayEffectiveTrackUrl: "",
        trackUrlGroupId: "",
      },
      visible: false,
      modalType: "",
      selectedData: {},
      rules: {
        trackUrlGroupName: [{ required: true, message: "请输入监测链接名称", trigger: ["blur"] }],
        actionTrackUrl: [
          { required: true, message: "请输入有效触点链接", trigger: ["blur"] },
          { validator: validateUrl, trigger: ["blur"] },
        ],
        trackUrl: [{ validator: validateUrl, trigger: ["blur"] }],
        videoPlayTrackUrl: [{ validator: validateUrl, trigger: ["blur"] }],
        videoPlayDoneTrackUrl: [{ validator: validateUrl, trigger: ["blur"] }],
        videoPlayEffectiveTrackUrl: [{ validator: validateUrl, trigger: ["blur"] }],
      },
    };
  },
  methods: {
    showModal(type, data, editData) {
      this.visible = true;
      this.modalType = type;
      this.selectedData = data;
      if (type === "add") {
        this.ruleForm = {
          trackUrlGroupName: "",
          trackUrl: "",
          actionTrackUrl: "",
          videoPlayTrackUrl: "",
          videoPlayDoneTrackUrl: "",
          videoPlayEffectiveTrackUrl: "",
          trackUrlGroupId: null,
        };
      } else {
        console.log(editData);
        const {
          action_track_url,
          track_url,
          track_url_group_id,
          track_url_group_name,
          video_play_done_track_url,
          video_play_effective_track_url,
          video_play_track_url,
        } = editData;

        this.ruleForm = {
          trackUrlGroupName: track_url_group_name,
          trackUrl: track_url,
          actionTrackUrl: action_track_url,
          videoPlayTrackUrl: video_play_track_url,
          videoPlayDoneTrackUrl: video_play_done_track_url,
          videoPlayEffectiveTrackUrl: video_play_effective_track_url,
          trackUrlGroupId: track_url_group_id,
        };
      }
    },
    cancelForm() {
      this.visible = false;
    },
    saveForm(formName) {
      this.$refs[formName].validate((valid) => {
        const { advertiserId, assetId } = this.selectedData;
        if (valid) {
          createTrack_tt({
            ...this.ruleForm,
            advertiserId,
            assetId,
            optStatus: this.modalType === "add" ? 0 : 1,
          }).then((res) => {
            if (res.code === "0000") {
              this.$emit("successCallBack");
              this.visible = false;
              this.$message({
                message: "操作成功",
                type: "success",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    clearForm() {
      this.$refs.ruleForm.clearValidate();
    },
  },
  watch: {
    ruleFormProps: function(val) {
      this.ruleForm = val;
    },
  },
};
</script>

<style scoped lang="less">
.demo-ruleForm {
}
</style>
